export const getCurrentEnvironmentName = () => "";
